export default "__VITE_ASSET__D7lJKV9A__"